<template>
    <CCard>    
        <CCardBody>  
            <CCol sm="12" lg="12" style="padding-left: 0px; padding-right: 0px;">  
                <div class="content-wrapper">
                    <div id="app">                      
                        <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                            <ejs-grid ref='refdata' :dataSource='datas' height='60vh' :allowExcelExport='true' :allowPaging='true' :allowSorting='true' :allowFiltering='true' :allowReordering='true'
                                :toolbar='toolbar' :pageSettings='pageSettings' :filterSettings='filterSettings' :selectionSettings='selectionSettings' :toolbarClick="toolbarClick"
                                :editSettings='editSettings' :recordDoubleClick="recordDoubleClick" :beforeRender="beforeRender" :rowSelected='rowSelected' 
                                :queryCellInfo='onQueryCellInfo' :rowDataBound="onRowDataBound">
                                <e-columns>       
                                  <e-column field='bill_id' headerText='入庫單號' aria-required="true" :isPrimaryKey='true' width='180'></e-column>
                                  <e-column field='bill_date'  format="yyyy-MM-dd" type="date" headerText='入庫日期' width='160'></e-column>          
                                  <e-column field='bill_state_name' headerText='單據狀態' width='120'></e-column>          
                                  <e-column field='warehouse_id' headerText='倉庫編號' width='130'></e-column>   
                                  <e-column field='style_id' headerText='款式編號' width='130'></e-column>  
                                  <e-column field='std_pages' headerText='每卷張數' width='140' format="N0" textAlign="Right" ></e-column>  
                                  <e-column field='produce_pages' headerText='生產張數' width='140' format="N0" textAlign="Right" ></e-column>  
                                  <e-column field='total_pages' headerText='入庫張數合計' width='160' format="N0" textAlign="Right" ></e-column>  
                                  <e-column field='total_bad_pages' headerText='壞品張數合計' width='160' format="N0" textAlign="Right" ></e-column>  
                                  <e-column field='real_total_pages' headerText='實際入庫張數' width='160' format="N0" textAlign="Right" ></e-column>  
                                  <e-column field='upload_images' headerText='上傳圖檔數量' width='160' format="N0" textAlign="Right" ></e-column>  
                                  <e-column field='production_unit_id' headerText='生產單位' width='130'></e-column> 
                                  <e-column field='production_bill_id' headerText='生產單號' width='150'></e-column> 
                                  <e-column field='start_label_no' headerText='起始序號' width='180'></e-column>  
                                  <e-column field='end_label_no' headerText='結束序號' width='180'></e-column>  
                                  <e-column field='invalid_bill_id' headerText='作廢單號' width='180'></e-column>                                                     
                                  <e-column field='create_date' headerText='建檔日期' width='180'></e-column>
                                  <e-column field='create_id' headerText='建檔人員' width='140'></e-column>
                                  <e-column field='modify_date' headerText='異動日期' width='180'></e-column>
                                  <e-column field='modify_id' headerText='異動人員' width='140'></e-column>
                                </e-columns>                              
                            </ejs-grid>
                        </ejs-tooltip>
                    </div>
                </div>
            </CCol>
            <div class="dialog">
                <div class="control-section">
                    <ejs-dialog ref="modalDialog" :showCloseIcon='true' :isModal='true' :closeOnEscape='true' :visible='false' :header='e_isAdd ? "新增標籤入庫單" : "修改標籤入庫單"' :buttons='e_buttons' 
                        width='50%'>
                        <div formGroup="orderForm">                       
                            <div class="form-row">                          
                                <div class="form-group col-md-4">
                                  <span class="about-title-verify">入庫單號</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_bill_id" :enabled="e_isAdd" aria-required="true"></ejs-textbox>                              
                                </div>                                
                                <div class="form-group col-md-4">
                                  <span class="about-title-verify">入庫日期</span>
                                  <ejs-datepicker id="datepicker" v-model="e_bill_date" format="yyyy-MM-dd"></ejs-datepicker>                                
                                </div>
                                <div class="form-group col-md-4" style="top: 20px;">
                                  <ejs-button :isPrimary="true" v-show="e_isAdd" v-on:click.native='onLoadProduction'>載入生產單</ejs-button>                             
                                </div>
                                <div class="form-group col-md-8">
                                  <span class="about-title-verify">標籤款式</span>
                                  <ejs-dropdownlist id='enterprise' cssClass="custom-dropdown"  :dataSource='style_datas' :select="onLBStyleSelect" :allowFiltering='true' :fields='fields' v-model="e_style_id" :enabled="false"></ejs-dropdownlist>
                                </div>   
                                <div class="form-group col-md-4">
                                  <span class="about-title-verify">生產單號</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_production_bill_id"  aria-required="true"  :enabled="false"></ejs-textbox>    
                                </div> 
                                <div class="form-group col-md-4">
                                  <span class="about-title-verify" >生產張數</span>                      
                                  <ejs-numerictextbox id="numeric" format="### 張"  v-model="e_produce_pages" :enabled="false" :min="0"></ejs-numerictextbox>                           
                                </div>   
                                <div class="form-group col-md-4">
                                  <span class="about-title-verify" >每卷張數</span>                      
                                  <ejs-numerictextbox id="numeric" format="### 張"  v-model="e_std_pages" :enabled="false" :min="0"></ejs-numerictextbox>                           
                                </div>  
                                <div class="form-group col-md-4">
                                  <span class="about-title-verify" >生產卷數</span>
                                  <ejs-numerictextbox id="numeric" format="### 卷" v-model="e_volumes"  @change="updateLiter($event, index)" :min="0" :enabled="false"></ejs-numerictextbox>
                                </div> 
                                <div class="form-group col-md-4">
                                  <span class="about-title">標籤起始序號</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_start_label_no" :enabled="false"></ejs-textbox>    
                                </div>  
                                <div class="form-group col-md-4">
                                  <span class="about-title">標籤結束序號</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_end_label_no" :enabled="false" ></ejs-textbox>    
                                </div>  
                                <div class="form-group col-md-4">
                                  <span class="about-title-verify">生產單位</span>                               
                                  <ejs-dropdownlist id='unit' cssClass="custom-dropdown"  :dataSource='productionunit_datas' :enabled="false" :fields='fields' v-model="e_production_unit_id" ></ejs-dropdownlist>
                                </div>  
                                                       
                                <div class="form-group col-md-4"> 
                                  <span class="about-title-verify">入庫倉庫</span> 
                                  <ejs-dropdownlist id='unit' cssClass="custom-dropdown"  :dataSource='warehouse_datas' :fields='fields' v-model="e_warehouse_id" ></ejs-dropdownlist>
                                </div>  
                                <div class="form-group col-md-4">
                                  <span class="about-title">來源單號</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_source_bill_id"  aria-required="true"></ejs-textbox>    
                                </div>   
                                <div class="form-group col-md-4"> 
                                  <span class="about-title-verify">單況</span>
                                  <ejs-dropdownlist id='unit' cssClass="custom-dropdown" :dataSource='stock_datas' :enabled="false"  :fields='fields' v-model="e_bill_state" ></ejs-dropdownlist>
                                </div>    
                                <div class="form-group col-md-6">
                                  <span class="about-title">狀態說明</span>   <br/>  
                                  <div style="padding-top: 8px;">     
                                  序號入庫： <span style="color: red;"> {{ e_is_no_in_stock ? "是" : "否" }} </span> &nbsp;&nbsp;&nbsp;
                                  圖檔檢查： <span style="color: red;"> {{ e_is_check_image ? "是" : "否" }} </span> &nbsp;&nbsp;&nbsp; 
                                  壞品作廢： <span style="color: red;"> {{ e_invalid_bad ? "是" : "否" }} </span> &nbsp;&nbsp;&nbsp; 
                                  圖檔入庫： <span style="color: red;"> {{ e_is_image_in_stock ? "是" : "否" }} </span> &nbsp;&nbsp;&nbsp;      
                                  </div>            
                                </div>    
                                <div class="form-group col-md-6">                                  
                                  <div style="padding-top: 8px;">     
                                    <ejs-button :isPrimary="true" v-show="!e_isAdd" :disabled="e_bill_state != 0" v-on:click.native='onPackageSearch(0)'>序號入庫</ejs-button>  &nbsp;          
                                    <ejs-button :isPrimary="true" v-show="!e_isAdd" :disabled="e_bill_state != 2 && e_bill_state != 4" v-on:click.native='onPackageSearch(2)'>圖檔檢查</ejs-button>  &nbsp;  
                                    <ejs-button :isPrimary="true" v-show="!e_isAdd" :disabled="e_bill_state != 4 && e_bill_state != 5" v-on:click.native='onBadList'>壞品清單</ejs-button>  &nbsp; 
                                    <ejs-button :isPrimary="true" v-show="!e_isAdd" :disabled="e_bill_state != 5" v-on:click.native='onPackageSearch(5)'>圖檔入庫</ejs-button>            
                                  </div>            
                                </div>                                
                                
                                <div class="form-group col-md-12">
                                  <span class="about-title">備註</span>
                                  <ejs-textbox floatLabelType="Always" :rows="1" :multiline="true" v-model="e_memo"  aria-required="true"></ejs-textbox>    
                                </div>  
                                <div class="form-group col-md-12">   
                                  <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                                    <ejs-grid ref='ref_contact_data' :dataSource='contact_datas' height='150' :allowExcelExport='true' :allowPaging='false' :allowSorting='false' :allowFiltering='false' :allowReordering='false'
                                      :pageSettings='pageSettings' :filterSettings='filterSettings' :selectionSettings='selectionSettings' :toolbarClick="toolbarClick"                                   
                                      :queryCellInfo='onQueryCellInfo' :rowDataBound="onRowDataBound" >
                                      <e-columns>                   
                                        <e-column field='row_id' headerText='序號' aria-required="true" width='80'></e-column>                                   
                                        <e-column field='volume_no' headerText='標籤卷編號' width='160' ></e-column>
                                        <e-column field='start_label_no' headerText='起始序號' width='160' :allowEditing='false'></e-column>      
                                        <e-column field='end_label_no' headerText='結束序號' width='160'  :allowEditing='false' ></e-column>                             
                                        <e-column field='pages' headerText='張數' width='120' format="N0" :allowEditing='false' textAlign="Right"  ></e-column>                    
                                        <e-column field='is_check_image' headerText='圖檔檢查狀態' width='140' :allowEditing='false' ></e-column>   
                                        <e-column field='bad_pages' headerText='壞品張數' width='160' format="N0"  textAlign="Right"  :allowEditing='false' ></e-column>           
                                        <e-column field='real_pages' headerText='實際張數' width='160' format="N0"  textAlign="Right"  :allowEditing='false' ></e-column>                
                                      </e-columns>                              
                                    </ejs-grid>
                                  </ejs-tooltip>
                              </div> 
                            </div>
                        </div>                
                    </ejs-dialog>
                </div>    
            </div>
            <div class="dialog2">
                <div class="control-section">
                    <ejs-dialog ref="modalDialog2" :showCloseIcon='true' :isModal='true' :closeOnEscape='true' :visible='false' header='載入生產單' :buttons='e_buttons_load_production' 
                        width='50%'>
                        <div formGroup="orderForm">                       
                            <div class="form-row">                              
                                <div class="form-group col-md-12">                      
                                  <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                                    <ejs-grid ref='ref_contact_data' :dataSource='production_datas' height='50vh' :allowExcelExport='true' :allowPaging='true' :allowSorting='true' :allowFiltering='true' :allowReordering='true'
                                      :toolbar='toolbarContact'  :pageSettings='pageSettings' :filterSettings='filterSettings' :selectionSettings='selectionSettings' :toolbarClick="toolbarClick"
                                      :editSettings='editSettings' :recordDoubleClick="recordContactDoubleClick" :beforeRender="beforeRender" :rowSelected='rowProductionSelected' 
                                      :queryCellInfo='onQueryCellInfo' :rowDataBound="onRowDataBound" >
                                      <e-columns>                   
                                        <e-column field='bill_id' headerText='生產單號' aria-required="true" :isPrimaryKey='true' width='180'></e-column>
                                        <e-column field='bill_date'  format="yyyy-MM-dd" type="date" headerText='生產日期' width='180'></e-column>          
                                        <e-column field='bill_state_name' headerText='單況' width='120'></e-column>          
                                        <e-column field='source_bill_id' headerText='來源單號' width='180'></e-column>   
                                        <e-column field='production_unit_id' headerText='生產單位' width='140'></e-column>       
                                        <e-column field='schedule_bill_id' headerText='排程序號' width='140'></e-column>  
                                        <e-column field='style_id' headerText='款式編號' width='140'></e-column>  
                                        <e-column field='std_pages' headerText='每卷張數' width='140' format="N0" textAlign="Right" ></e-column>  
                                        <e-column field='produce_pages' headerText='生產張數' width='140' format="N0" textAlign="Right" ></e-column>  
                                        <e-column field='start_label_no' headerText='標籤起始序號' width='180'></e-column>  
                                        <e-column field='end_label_no' headerText='標籤結束序號' width='180'></e-column>      
                                      </e-columns>                              
                                    </ejs-grid>
                                  </ejs-tooltip>
                              </div> 
                            </div>
                        </div>                
                    </ejs-dialog>
                </div>    
            </div>
             <div class="dialog3">
                <div class="control-section">
                    <ejs-dialog ref="modalDialog3" :showCloseIcon='true' :isModal='true' :closeOnEscape='true' :visible='false' header='壞品清單' 
                        width='50%'>
                        <div formGroup="orderForm">                       
                            <div class="form-row">                              
                                <div class="form-group col-md-12">                      
                                  <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                                    <ejs-grid ref='ref_badlist_data' :dataSource='production_badlist_datas' height='50vh' :allowExcelExport='true' :allowPaging='true' :allowSorting='true' :allowFiltering='true' :allowReordering='true'
                                      :toolbar='toolbarBadList' :pageSettings='pageSettings' :filterSettings='filterSettings' :selectionSettings='selectionSettings' :toolbarClick="toolbarClick"
                                      :beforeRender="beforeRender"  :queryCellInfo='onQueryCellInfo' :rowDataBound="onRowDataBound" >
                                      <e-columns>                   
                                        <e-column field='label_no' headerText='標籤序號'  width='180'></e-column>
                                        <e-column field='volume_no' headerText='標籤捲捲號' width='180'></e-column>          
                                        <e-column field='msg' headerText='壞品原因' width='420'></e-column>                                       
                                      </e-columns>                              
                                    </ejs-grid>
                                  </ejs-tooltip>
                              </div> 
                            </div>
                        </div>                
                    </ejs-dialog>
                </div>    
            </div>
            <ejs-toast ref='toastRef' id='toast_type' :position='position'></ejs-toast>      
        </CCardBody>
    </CCard>  
</template>



<style lang="scss" src="../../scss/grid.scss"></style>
<script lang="ts">

import Vue from "vue";
import { Query } from '@syncfusion/ej2-data';
import Loading from 'vue-loading-overlay';
import { DialogUtility } from '@syncfusion/ej2-popups';
import { ButtonComponent } from "@syncfusion/ej2-vue-buttons";
import { ToastComponent } from "@syncfusion/ej2-vue-notifications";
import { DatePickerComponent } from "@syncfusion/ej2-vue-calendars";
import { L10n, setCulture, enableRipple } from '@syncfusion/ej2-base';
import { DialogPlugin, TooltipPlugin } from '@syncfusion/ej2-vue-popups';
import { NumericTextBoxComponent } from "@syncfusion/ej2-vue-inputs";
import { GridComponent, ColumnDirective, ColumnsDirective, GridPlugin, DetailRow, PdfExport, ExcelExport, Sort, Edit, Page, Filter, Reorder, Toolbar, Search } from "@syncfusion/ej2-vue-grids";
import { DropDownListComponent } from '@syncfusion/ej2-vue-dropdowns';


setCulture('en-US');
L10n.load({
  'en-US': {
    'pager': {
      'currentPageInfo': '',
      'totalItemsInfo': '{1} to {2} of {0}',
    },
    'grid': {
      'Print': '列印',
      'Search': '搜尋',
      'Add': '新增',
      'Edit' : '修改',
      'Delete' : '刪除',
      'Update' : '確認',
      'Cancel' : '取消'
    }
  }
});

enableRipple(true);
Vue.use(DialogPlugin);
Vue.use(TooltipPlugin);
Vue.use(GridPlugin);
Vue.use(Loading);

let DialogObj   = undefined;
let Loader      = undefined;


export default {
  name: 'Department',
  components: {   
    'ejs-button': ButtonComponent,
    'ejs-toast': ToastComponent,
    'ejs-datepicker': DatePickerComponent,
    'ejs-numerictextbox': NumericTextBoxComponent,
    'ejs-grid': GridComponent,
    'e-column': ColumnDirective,
    'e-columns': ColumnsDirective,
    'ejs-dropdownlist': DropDownListComponent
  },
  data: function () {
    return {
      e_selectRow : null, e_selectData: null, e_selectProductionData: null,
      e_isAdd: null, 
      
      e_bill_id: null, e_bill_date: null, e_style_id : null, e_source_bill_id : null, 
      e_produce_pages: null, e_std_pages: null, e_volumes : null, e_start_label_no : null, 
      e_end_label_no: null, e_production_unit_id : null, e_invalid_bad : null, e_is_check_image : null, 
      e_is_image_in_stock : null, e_is_no_in_stock: null, e_production_bill_id : null, e_real_total_pages : null, 
      e_total_bad_pages : null, e_total_pages : null,   e_upload_images : null, e_warehouse_id: null, e_invalid_bill_id : null, 
      e_work_no1: null, e_work_no2: null, e_work_no3: null, e_bill_state : null, e_memo: null, 
      
      e_buttons: [
        {click: this.editOkClick, buttonModel: { content: '確認', isPrimary: true } }, 
        {click: function() { this.hide(); },buttonModel: { content: '取消', isPrimary: false}}
      ],
      e_buttons_load_production: [
        {click: this.edit_load_productionOkClick, buttonModel: { content: '確認' } }, 
        {click: function() { this.hide(); },buttonModel: { content: '取消'}}
      ],
   
      filterSettings: { type: 'CheckBox' },
      pageSettings: { pageSize: 15, pageSizes: [10, 50, 100, 200], pageCount: 4 },
      selectionSettings: { persistSelection: true },
      editSettings: { allowEditing: false, allowAdding: false, allowDeleting: false, showAddNewRow: false },
      editContactSettings: { allowEditing: true, allowAdding: true, allowDeleting: true, showAddNewRow: true, newRowPosition: 'Bottom' },
      toolbar: null,
      toolbarBadList: null,
      toolbarContact: [
         { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'ContactExport' }, 
         'Print',
         'Search'
        ],
 
      datas:  [], contact_datas: [], production_datas: [], productionunit_datas:  [], stock_datas: [], warehouse_datas:  [], style_datas: [], production_badlist_datas: [],
      position: { X: 'Right', Y: "Bottom" }, ShowBtn: false,
      fields: { value: 'value', text: 'text'},     

      yesNoParams : {
        params: {
          allowFiltering: true,
          dataSource: [{ value: true, text: '是' }, { value: false, text: '否' }],
          query: new Query(),
          fields: { value: 'value', text: 'text'},         
        },
      },
    
      isGiftTemplate: function () { return { 
          template: Vue.component("isGiftTemplate", {
          template:  `<div>{{name}}</div>`,             
          computed: {
              name: function() {
                  return this.data.is_gift ? "是" : "否";
              }
          }
      })}},
      isEstimateTemplate: function () { return { 
          template: Vue.component("isEstimateTemplate", {
          template:  `<div>{{name}}</div>`,              
          computed: {
              name: function() {
                  return this.data.is_estimate ? "是" : "否";
              }
          }
      })}},
      isCloseTemplate: function () { return { 
          template: Vue.component("isCloseTemplate", {
          template:  `<div>{{name}}</div>`,            
          computed: {
              name: function() {
                  return this.data.is_close ? "是" : "否";
              }
          }
      })}},
      dateTemplate: function () { return { 
          template: Vue.component("dateTemplate", {
          template:  `<div>{{name}}</div>`,            
          computed: {
              name: function() {
                  return this.pre_deliver_date.toISOString().split('T')[0]
              }
          }
      })}},
      
    };
  },
  methods: {    
    toolbarClick: function (args) {     

      if (args.item.id == 'Delete') {
        DialogObj = DialogUtility.confirm({
            title: '刪除資料',
            content: `確認是否要刪除入庫單號${this.e_selectData.bill_id}的資料嗎?`,
            okButton: {  text: '是', click: this.delOkClick },
            cancelButton: {  text: '否', click: this.delCancelClick },
            showCloseIcon: true,
            closeOnEscape: true,
            animationSettings: { effect: 'Fade' }
        });
      }
      if (args.item.id == 'Add') {    

        // this.e_production_unit_id  = this.productionunit_datas[0].value;
        this.e_isAdd = true;
        this.e_bill_id = "";
        this.e_bill_date  = new Date();      
        this.e_style_id = "";
        this.e_source_bill_id = "";
        this.e_produce_pages = "";
        this.e_std_pages= "";
        this.e_volumes= "";
        this.e_start_label_no= "";
        this.e_end_label_no = "";
        this.e_production_unit_id = "";
        this.e_invalid_bad = false;
        this.e_is_check_image = false;
        this.e_is_image_in_stock = false;
        this.e_is_no_in_stock = false;
        this.e_production_bill_id = "";
        this.e_real_total_pages = "";
        this.e_total_bad_pages = "";
        this.e_total_pages = "";
        this.e_upload_images = 0;
        this.e_warehouse_id = this.warehouse_datas[0].value;
        this.e_invalid_bill_id = "";
        this.e_work_no1 = "";
        this.e_work_no2 = "";
        this.e_work_no3 = "";
        this.e_bill_state = "";
        this.contact_datas = [];
        this.getNumber();
        this.$refs.modalDialog.show();    
      }
      if (args.item.id == 'Edit') {
        this.recordDoubleClick(); 
      }

      if (args.item.id == "Export") {
        this.$refs.refdata.excelExport({ fileName:'標籤訂購單.xlsx' });
      }   
      if (args.item.id == "ContactExport") {
        this.$refs.ref_contact_data.excelExport({ fileName:'載入生產單.xlsx' });
      }   
      if (args.item.id == "BadListExport") {
        this.$refs.ref_badlist_data.excelExport({ fileName:'壞品清單.xlsx' });
      }   
      if (args.item.id == "Refresh") {
        this.getLBStockMain();       
      }
      if (args.item.id == "PrintOnly") {     
        fetch(this.e_selectData.report_url, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        })
          .then(res => res.blob())
          .then(blob => {
            const url = URL.createObjectURL(blob);
            window.open(url, "_blank"); // 用 Blob URL 開新頁
          });
      }
     
      if (args.item.id == "BadListConfim") {   
        this.onPackageSearch(4);
        this.$refs.modalDialog3.hide();   
      }
        if (args.item.id == "BadListCancel") {   
         this.onPackageSearch(3);
         this.$refs.modalDialog3.hide();   
      }

    },   
    onLoadProduction: function() {
      this.getProductionMainUse();
      this.$refs.modalDialog.hide();    
      this.$refs.modalDialog2.show();    
    },
    
    onQueryCellInfo(args) {     
      if (args.cell) {
        args.cell.classList.add("tooltip-cell");
        args.cell.setAttribute("title", `${args.column.headerText}: ${args.data[args.column.field]}`);
      }
    },
    onRowDataBound(args) {
      if (args.data.state == 2) {
        args.row.style.backgroundColor = "rgba(255, 229, 255, 0.8)"; // 數量少於 3，淡紅色
      } 
    },     
    checkHeader: function() {       
      this.toolbar =  [
        { text: '新增', tooltipText: '新增', prefixIcon: 'e-btn-icon e-add e-icons e-icon-left', id: 'Add' , disabled: false },
        { text: '修改', tooltipText: '修改', prefixIcon: 'e-btn-icon e-edit e-icons e-icon-left', id: 'Edit', disabled: this.e_selectRow == undefined },
        { text: '刪除', tooltipText: '刪除', prefixIcon: 'e-btn-icon e-delete e-icons e-icon-left', id: 'Delete', disabled: this.e_selectRow == undefined },      
        { text: '重整', tooltipText: '重整', prefixIcon: 'e-btn-icon e-refresh e-icons e-icon-left', id: 'Refresh' }, 
        { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' }, 
       // { text: '單筆列印', tooltipText: '單筆列印', prefixIcon: 'e-btn-icon e-print e-icons e-icon-left', id: 'PrintOnly' }, 
        'Print', 'Search'];
  
      if (this.e_selectData != undefined ) {
        this.toolbarBadList = [
          { text: '清單確認', tooltipText: '清單確認', prefixIcon: 'e-btn-icon e-play e-icons e-icon-left', id: 'BadListConfim' , disabled: this.e_selectData.bill_state != 4 },
          { text: '清單取消', tooltipText: '清單取消', prefixIcon: 'e-btn-icon e-cancel e-icons e-icon-left', id: 'BadListCancel', disabled: this.e_selectData.bill_state != 5},     
          { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'BadListExport' }, 
          'Search',
          'Print'];
      } 
    },
    updateLiter: function(event, index) { 
      
      this.e_produce_pages = this.e_std_pages * event.value;
      console.log(index);
    },

    checkZero : function (data){
      if(data.length == 1){
        data = "0" + data;
      }
      return data;
    },
      
    rowProductionSelected: function(args) {    
      this.e_selectProductionData = args.data;   
    },
    rowSelected: function(args) {    
      this.e_selectRow = args.row.getAttribute('aria-rowindex');     
      this.e_selectData = args.data;   
      this.getStockSub(args.data.bill_id);
      this.checkHeader();
    },
    onPackageSearch: function(status) {
      this.showLoading();
      this.axios({
          method: 'put',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'LBStock/Status',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {
            bill_id: this.e_selectData.bill_id,
            bill_status : status
          }
      })
      .then((response) => {       
        this.hideLoading();
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; } 
        this.showMsg('修改成功!');           
        this.$refs.modalDialog.hide();       
        this.getLBStockMain();       
      })
      .catch((error) => { this.showError(error, true) }
      ) 
    },
    onBadList: function() {
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `LBStock/Main/BadList?bill_id=${this.e_bill_id}`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },        
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; } 
        this.production_badlist_datas = response.data.datas;  
        this.$refs.modalDialog3.show();      
        this.$refs.modalDialog.hide();      
      })
      .catch((error) => { this.showError(error, true) }
      ) 
    },

    delOkClick: function() {
      DialogObj.hide();
      this.showLoading();
      this.axios({
          method: 'delete',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'LBStock',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {
            bill_id: this.e_selectData.bill_id
          }
      })
      .then((response) => {       
        this.hideLoading();
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; } 
        this.showMsg('刪除成功!');              
        this.getLBStockMain();       
      })
      .catch((error) => { this.showError(error, true) }
      ) 
    },   
    calculateTotalCost: function() {   
      const formEle = this.$refs.ref_contact_data.$el.ej2_instances['0'].element.querySelector('form')['ej2_instances'][0];
      formEle.getInputElement('pages').value = formEle.getInputElement('style_pages').value * formEle.getInputElement('volumes').value;
      formEle.getInputElement('no_deliver_volumes').value = formEle.getInputElement('volumes').value;      
    },      
    delCancelClick: function() {
       this.showMsg(this.e_isAdd ? '新增成功!' : '修改成功!');     
       DialogObj.hide();
    },    
    edit_load_productionOkClick: function() {     
      this.e_style_id = this.e_selectProductionData.style_id; 
      this.e_production_bill_id = this.e_selectProductionData.bill_id;
      this.e_produce_pages = this.e_selectProductionData.produce_pages;
      this.e_std_pages = this.e_selectProductionData. std_pages;
      this.e_volumes = this.e_selectProductionData.volumes;
      this.e_start_label_no = this.e_selectProductionData.start_label_no;
      this.e_end_label_no = this.e_selectProductionData.end_label_no;
      this.e_production_unit_id = this.e_selectProductionData.production_unit_id;
      this.e_bill_state = "0";
      this.e_total_pages = this.e_selectProductionData.produce_pages;
      this.e_total_bad_pages = 0;
      this.e_real_total_pages = this.e_selectProductionData.produce_pages;
      this.getProductionSub(this.e_production_bill_id );
      this.$refs.modalDialog2.hide();    
      this.$refs.modalDialog.show();    
    },
    editOkClick: function() {           

      this.showLoading();
      if (this.e_isAdd) {
        this.axios({
          method: 'post',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'LBStock',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {
            main: {

              bill_id: this.e_bill_id,
              bill_date: this.e_bill_date,
              production_bill_id:  this.e_production_bill_id,
              source_bill_id: this.e_source_bill_id,              
              style_id: this.e_style_id,
              produce_pages: this.e_produce_pages,
              std_pages: this.e_std_pages,
              volumes: this.e_volumes,
              start_label_no:  this.e_start_label_no,
              end_label_no:  this.e_end_label_no,
              warehouse_id: this.e_warehouse_id,
              production_unit_id: this.e_production_unit_id,
              total_pages: this.e_total_pages,
              total_bad_pages: this.e_total_bad_pages,
              real_total_pages: this.e_real_total_pages,
              upload_images: this.e_upload_images,
              is_no_in_stock:  this.e_is_no_in_stock,
              is_check_image: this.e_is_check_image,
              is_image_in_stock:this.e_is_image_in_stock,
              invalid_bad:  this.e_invalid_bad,
              invalid_bill_id: this.e_invalid_bill_id,
              bill_state: this.e_bill_state,          
              memo:  this.e_memo,
            }, sub : 
            this.contact_datas
          }
        })
        .then((response) => {       
          if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; } 
          this.showMsg('新增成功!');     
          this.$refs.modalDialog.hide();    
          this.hideLoading();
          this.getLBStockMain();       
        })
        .catch((error) => { this.showError(error, true) }
        ) 
      } else {
        this.axios({
          method: 'put',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'LBStock',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {          
            bill_id: this.e_bill_id,
            bill_date: this.e_bill_date,              
            source_bill_id: this.e_source_bill_id,  
            memo:  this.e_memo            
          }
        })
        .then((response) => {       
          if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; } 
          this.showMsg('修改成功!');     
          this.$refs.modalDialog.hide();    
          this.hideLoading();
          this.getLBStockMain();       
        })
        .catch((error) => { this.showError(error, true) }
        ) 
      }
     

    },
    recordContactDoubleClick  : function () {     
      this.edit_load_productionOkClick();
    },
    recordDoubleClick: function () {         
      this.e_isAdd = false;

      this.e_bill_id = this.e_selectData.bill_id;
      this.e_bill_date = new Date(this.e_selectData.bill_date);
      this.e_style_id = this.e_selectData.style_id;
      this.e_source_bill_id = this.e_selectData.source_bill_id;
      this.e_produce_pages = this.e_selectData.produce_pages;
      this.e_std_pages = this.e_selectData.std_pages; 
      this.e_volumes = this.e_selectData.volumes;
      this.e_start_label_no = this.e_selectData.start_label_no;
      this.e_end_label_no = this.e_selectData.end_label_no;
      this.e_production_unit_id = this.e_selectData.production_unit_id;
      this.e_invalid_bad = this.e_selectData.invalid_bad;
      this.e_is_check_image = this.e_selectData.is_check_image; 
      this.e_is_image_in_stock = this.e_selectData.is_image_in_stock;
      this.e_is_no_in_stock = this.e_selectData.is_no_in_stock; 
      this.e_production_bill_id = this.e_selectData.production_bill_id;
      this.e_real_total_pages = this.e_selectData.real_total_pages;
      this.e_total_bad_pages = this.e_selectData.total_bad_pages;
      this.e_total_pages = this.e_selectData.total_pages;
      this.e_upload_images = this.e_selectData.upload_images;
      this.e_warehouse_id = this.e_selectData.warehouse_id;
      this.e_invalid_bill_id = this.e_selectData.invalid_bill_id; 
      this.e_work_no1 = this.e_selectData.work_no1;
      this.e_work_no2 = this.e_selectData.work_no2;
      this.e_work_no3 = this.e_selectData.work_no3;
      this.e_bill_state = this.e_selectData.bill_state.toString();
      this.e_memo = this.e_selectData.memo; 
      this.checkHeader();
      this.$refs.modalDialog.show();  
    },
    beforeRender: function (args) {
      if (args.target.closest("td")) {
        this.$refs.tooltip.content = args.target.innerText;
      }
    },
    onLBStyleSelect: function(e) {
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `LBStyle/ID?id=${e.item.dataset.value}`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }               
          this.e_std_pages = response.data.datas.std_pages;       
          this.e_produce_pages = this.e_std_pages * this.e_volumes;
      })
      .catch((error) => { this.showError(error, true) }
      )      
    },
    getLBStockMain: function () {           
      this.showLoading();
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'LBStock/Main',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
          this.hideLoading();         
          this.datas = response.data.datas      
          this.e_selectRow = null;
          this.e_selectData = null;
          this.checkHeader();
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },
    getStockSub: function (bill_id) {           
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `LBStock/Sub?bill_id=${bill_id}`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
       
          this.contact_datas = response.data.datas      
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },
    getProductionMainUse: function () {           
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `LBProduction/Main/Use`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
        this.production_datas = response.data.datas      
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },
    getWarehouse: function () {           
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/LBWarehouse/Dropdown`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
       
          this.warehouse_datas = response.data.datas      
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },
    getNumber: function () {           
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/General/Number?type=stockin`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
          this.e_bill_id = response.data.datas  
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },
    getLBStyle: function () {        
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/LBStyle/Dropdown`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
        this.style_datas = response.data.datas;        
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },
    getStockState: function () {           
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/LBStock/State`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
          this.stock_datas = response.data.datas      
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },
    getProductionUnit: function () {           
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/LBProduction/Unit/Dropdown`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }  
          this.productionunit_datas = response.data.datas      
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },
    getProductionSub: function (bill_id) {           
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `LBProduction/Sub?bill_id=${bill_id}`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }          
          this.contact_datas = [];    
          for (let key in response.data.datas) {
            this.contact_datas.push(
              {
                'bill_id' : this.e_bill_id,
                'bill_date' : this.e_bill_date,
                'row_id' : parseInt(key) + 1,               
                'volume_no' : response.data.datas[key].volumes_no,
                'start_label_no' : response.data.datas[key].start_label_no,
                'end_label_no' : response.data.datas[key].end_label_no,
                'pages' : this.e_std_pages,               
                'bad_pages' : 0,
                'real_pages' : this.e_std_pages,
                'is_check_image' : '否'
              })
          }          
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },

    showError: function (error) {     
      this.hideLoading();
      if (error.response.status == 400) {
        for(var key in error.response.data.errors){      
          this.$refs.toastRef.show( { title: '警告!', content: error.response.data.errors[key][0] , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
        }
        return;
      }   
      if (error.response.status == 401) {
        localStorage.removeItem('token'); this.$router.push('/login');
        return;
      }
      this.$refs.toastRef.show( { title: '錯誤!', content: error.response.status, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
    },
    showMsg: function (msg) {
      this.$refs.toastRef.show( { title: '訊息!', content: msg, cssClass: 'e-toast-info', icon: 'e-info toast-icons' });
    },
    showLoading() {
      Loader = this.$loading.show({
        container: this.$refs.loadingContainer,
        canCancel: true, // default false
        onCancel: this.yourCallbackMethod,
        color: 'blue',
        loader: 'bars',  // spinner, dots, bars
        width: 164,
        height: 164,
        backgroundColor: 'black',
        opacity: 0.5,
        zIndex: 999,
      });
    },
    hideLoading() {
        Loader.hide();
    }
  },
  provide: {
    grid: [PdfExport, ExcelExport, Sort, DetailRow, Edit, Page, Toolbar, Filter, Reorder, Search]
  },
  created() {
    this.checkHeader();
    this.getLBStockMain();
    this.getWarehouse();
    this.getStockState();
    this.getLBStyle();
    this.getProductionUnit();
  },
  mounted() {
  },
  beforeUpdate() {
  },
  beforeDestroy() {
  }
}
</script>
<style>
/* 設定 CustomerName 欄位的字體顏色 */
.blue-text {
  color: blue !important;
}

</style>
<style lang="scss" src="../../scss/base.scss"></style>
